import { createSelector } from 'reselect';
const getSearchSlice = state => state.search;
export const getSearchTerm = createSelector([getSearchSlice], slice => slice.searchTerm);
export const getLastValidSearchTerm = createSelector([getSearchSlice], slice => slice.lastValidSearchTerm);